import React, { useRef } from 'react';
import { Video } from '@fiverr-private/media';
import { Stack } from '@fiverr-private/layout_components';
import { FileType } from '@fiverr-private/bianka_js/protobuf/bianka/enums/assets_sharing/asset/file_type';
import { ControlVideo } from '../ControlMedia';
import { ExperientialPortfolioMediaComponentProps } from '../types';
import { useMediaControls } from '../ControlMedia/MediaControls';

export const VideoPreview = ({
  mediaUrl: videoUrl,
  previewUrl,
  onMediaClick,
}: ExperientialPortfolioMediaComponentProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const videoControls = useMediaControls(videoRef);

  const sources = [{ src: videoUrl || '', type: 'video/mp4' }];

  return (
    <Stack position="absolute" width="100%" height="100%" backgroundColor="black">
      <ControlVideo controls={videoControls} />
      <Video
        objectFit="contain"
        source={sources}
        preload="none"
        ref={videoRef}
        controls={false}
        poster={previewUrl}
        width="100%"
        height="100%"
        muted
        onPlay={() => {
          onMediaClick?.(FileType.VIDEO);
        }}
      />
    </Stack>
  );
};
